import React from "react";
import TailwindHeading from "../../components/_tailwind/heading";

type Props = {};

const StorybookSubHeading: React.ComponentType<Props> = ({ children }) => {
  return (
    <TailwindHeading level={6} margin={["mb-4"]}>
      {children}
    </TailwindHeading>
  );
};

export default StorybookSubHeading;
